@if(dataChat.isPoiSidebarOpen()){
    <div class="poi-sidebar">
        <div class="sidebar-content" >
            <!-- Header -->
            <div class="poi-header">
                <div class="poi-info">
                    <h4>{{ itemData()?.poi_name }}</h4>
                    <span class="badge">
                        @if(itemData()?.poi_type === 'event'){
                            {{ 'Evento' | translate }}
                        }
                        @else {
                            {{ 'Punto de interés' | translate }}
                        }
                    </span>
                </div>
                <div class="header-actions">
                    <button class="action-btn close-fully" (click)="close()" [title]="'Cerrar' | translate">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M18 6L6 18M6 6l12 12"/>
                        </svg>
                    </button>
                </div>
            </div>

            <!-- Iframe -->
            <div class="poi-content">
                 <!-- HRS-3045: la página de detalles (new-details + leaflet + chart.js + swiper,
                      ~800 KB raw) se separa en su propio chunk y solo se descarga al abrir el
                      sidebar. El @if interior mantiene el desmontaje al cambiar de POI/cerrar:
                      @defer por sí solo no desmonta el contenido una vez cargado. -->
                 @defer (when itemData()?.poi_id && itemData()?.poi_type) {
                     @if(itemData()?.poi_id && itemData()?.poi_type){
                         <item-details [id]="itemData().poi_id" [type]="itemData().poi_type" [isFromChatBot]="true" />
                     }
                 } @error {
                     <p class="poi-content__error">{{ 'No se ha encontrado el punto o evento' | translate }}</p>
                 }
            </div>

            <!-- Footer -->
            <div class="poi-footer">
                <div (click)="navigateToDetailsPage()" class="external-link">
                    <span>{{'Mostrar página de detalles' | translate}}</span>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3"/>
                    </svg>
                </div>
                
                <div class="nav-controls">
                    <button (click)="prev()" [disabled]="dataChat.activePoiIndex() === 0"> ‹ </button>
                    <div class="dots">
                        @for (p of dataChat.poiList(); track $index) {
                            <span [class.active]="$index === dataChat.activePoiIndex()" (click)="setActive($index)"></span>
                        }
                    </div>
                    <button (click)="next()" [disabled]="dataChat.activePoiIndex() === dataChat.poiList().length - 1"> › </button>
                </div>

            </div>
        </div>
    </div>
}
